import React, { useState, useEffect } from "react";
import logo from "../image/logo.webp";
import "../css/header.css";

function Header({ setShowModal }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-white fixed-top shadow-sm py-3">
        <div className="container">
          {/* Logo */}
          <a
            className="navbar-brand fw-bold d-flex align-items-center"
            href="/"
          >
            <img src={logo} width="120" className="ms-2" alt="logo" />
          </a>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Overlay for Mobile Drawer */}
          <div className={`drawer-overlay ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(false)}></div>

          {/* Menu */}
          <div
            className={`navbar-collapse justify-content-center mobile-drawer ${menuOpen ? "open" : ""}`}
          >
            {/* Drawer Header (Mobile Only) */}
            <div className="drawer-header d-lg-none d-flex justify-content-between align-items-center w-100 p-4 border-bottom">
              <img src={logo} width="120" alt="logo" />
              <button className="btn-close-drawer" onClick={() => setMenuOpen(false)}>&times;</button>
            </div>
            <ul className="navbar-nav gap-3 text-center" style={{ paddingLeft: "20px" }}>
              {/* <li className="nav-item">
                <a
                  className="nav-link active text-warning fw-semibold"
                  href="/"
                >
                  Home
                </a>
              </li> */}
              <li className="nav-item">
                <a className="nav-link active" href="#about" onClick={() => setMenuOpen(false)}>
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#top" onClick={() => setMenuOpen(false)}>
                  Top Categories
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#product" onClick={() => setMenuOpen(false)}>
                  Our Products
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#certificate" onClick={() => setMenuOpen(false)}>
                  Why Choose Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#test" onClick={() => setMenuOpen(false)}>
                  Our Testimonials
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact" onClick={() => setMenuOpen(false)}>
                  Contact Us
                </a>
              </li>
              <li className="nav-item d-lg-none mt-2">
                <button
                  className="btn appointment-btn px-4 w-100 shadow-sm"
                  onClick={() => { setShowModal(true); setMenuOpen(false); }}
                >
                  Book Appointment
                </button>
              </li>
            </ul>
          </div>

          {/* Right Actions */}
          <div className="d-none d-lg-flex align-items-center gap-3">
            {/* <i class="bi bi-search fs-5 text-secondary"></i> */}
            <button
              className="btn appointment-btn px-4"
              onClick={() => setShowModal(true)}
            >
              Book Appointment
            </button>
          </div>
        </div>
      </nav >
    </>
  );
}

export default Header;
